var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 0.75,
    y: 1.25,
    width: 37.5,
    height: 37.5,
    rx: 18.75,
    stroke: "#0A142F",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5507 27.5V19.9994H16V17.4146H17.5507V15.8626C17.5507 13.7539 18.4264 12.5 20.9142 12.5H22.9853V15.0851H21.6907C20.7223 15.0851 20.6582 15.4464 20.6582 16.1205L20.6547 17.4143H23L22.7256 19.9991H20.6547V27.5H17.5507Z",
    fill: "#0A142F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/Facebook Icon.7b663ec0781d8e8ba827d62a58df2239.svg";
export { ForwardRef as ReactComponent };